module.exports = __webpack_public_path__ + "static/media/1 30 skøyter.e27b6c2b.mp3";